const roleAccessEnum = Object.freeze({
  ADMIN_BIT: "00",
  SCHEDULE: "01",
  STAFF_LIST: "02",
  ROLE_SETTING: "03",
  RESERVATION: "04",
  CLUB_INFORMATION: "05",
  MEMBERSHIP_MANAGEMENT: "06",
  ACCOUNT: "07",
  DASHBOARD: "08",
});

export { roleAccessEnum };
